import React from 'react';
import { Box, Tooltip } from '@mui/material';
import type { FlatExecuteStep } from '@/types/run-stage.types';

interface StepPillProps {
  flatStep: FlatExecuteStep;
  isActive: boolean;
  onClick: () => void;
}

function getPillColor(step: FlatExecuteStep): string {
  const status = step.step.status?.toUpperCase();
  if (status === 'COMPLETED' || step.step.completed) return '#4caf50';
  if (status === 'IN_PROGRESS') return '#1976d2';
  if (status === 'SKIPPED') return '#ff9800';
  if (status === 'ABORTED') return '#f44336';
  return '#bdbdbd';
}

export const StepPill: React.FC<StepPillProps> = ({ flatStep, isActive, onClick }) => {
  const color = getPillColor(flatStep);

  return (
    <Tooltip title={flatStep.displayName} placement="top" arrow>
      <Box
        onClick={onClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onClick()}
        sx={{
          width: flatStep.isSubstep ? 24 : 32,
          height: flatStep.isSubstep ? 24 : 32,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: flatStep.isSubstep ? '0.6rem' : '0.7rem',
          fontWeight: 600,
          backgroundColor: color,
          color: '#fff',
          cursor: 'pointer',
          border: isActive ? '2px solid #000' : '2px solid transparent',
          outline: isActive ? '2px solid #1976d2' : 'none',
          flexShrink: 0,
          transition: 'transform 0.1s',
          '&:hover': {
            transform: 'scale(1.15)',
          },
          ml: flatStep.isSubstep ? 1 : 0,
        }}
      >
        {flatStep.pillLabel}
      </Box>
    </Tooltip>
  );
};
